<ion-header>
  <ion-toolbar>
    <ion-title>{{ modalTitle}}</ion-title>
    <ion-buttons slot="end">
      <ion-button *ngIf="!isViewAddress" (click)="saveDetails()">Save</ion-button>
      <ion-button (click)="dismissPopup()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form *ngIf="formType === 'PROFILE' " [formGroup]="userForm" class="smartdine-form">
    <ion-list class="pt-0">
      <ion-item>
        <div class="w-100 cover-image mb-2">
          <div class="avatar w-100 text-center">
            <img
              src="../../../../assets/img/profile-picture.png"
              alt="User Avatar"
              class="user-profile"
            />
          </div>
        </div>
      </ion-item>
      <ion-item lines="full">
        <ion-label>First Name<span class="text-danger">*</span></ion-label>
        <ion-input class="ion-text-end" formControlName="firstName"></ion-input>
      </ion-item>
      <div
        class="px-3 error-message"
        *ngIf="userForm.controls.firstName.errors?.required"
      >
        First Name is required.
      </div>
      <ion-item lines="full">
        <ion-label>Last Name<span class="text-danger">*</span></ion-label>
        <ion-input class="ion-text-end" formControlName="lastName"></ion-input>
      </ion-item>
      <div
        class="px-3 error-message"
        *ngIf="userForm.controls.lastName.errors?.required"
      >
        Last Name is required.
      </div>
      <ion-item>
        <ion-label>Phone number<span class="text-danger">*</span></ion-label>
        <ion-input
          class="ion-text-end"
          formControlName="phoneNumber"
        ></ion-input>
      </ion-item>
      <div
        class="px-3 error-message"
        *ngIf="userForm.controls.phoneNumber.errors?.required"
      >
        Phone number is required.
      </div>
      <ion-item lines="full" [disabled]="!isAdmin">
        <ion-label>Roles</ion-label>
        <ion-select multiple formControlName="roles" slot="end">
          <ion-select-option
            *ngFor="let role of roles"
            [value]="role.id"
            [innerText]="role.name"
          ></ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
  </form>

  <form *ngIf="formType === 'ADDRESS'" [formGroup]="userAddressForm" class="smartdine-form">
    <ion-list>
      <input type="hidden" formControlName="addressId" />
      <input type="hidden" formControlName="userId" />

      <ion-item lines="full">
        <ion-label [translate]="'ADDRESS_NAME'"></ion-label>
        <ion-input
          class="ion-text-end"
          id="addressName"
          type="text"
          formControlName="addressName"
        >
        </ion-input>
      </ion-item>
      
      <ion-item lines="full">
        <ion-label [translate]="'HOUSE_NUMBER'"></ion-label>
        <ion-input
          class="ion-text-end"
          id="houseNumber"
          type="text"
          formControlName="houseNumber"
        >
        </ion-input>
      </ion-item>
      
      <ion-item lines="full">
        <ion-label [translate]="'BUILDING_NAME'"></ion-label>
        <ion-input
          class="ion-text-end"
          id="buildingName"
          type="text"
          formControlName="buildingName"
        >
        </ion-input>
      </ion-item>

      <ion-item lines="full">

        <ion-label>
          <span translate="ADDRESS"></span><span class="required-star">*</span>
        </ion-label>

        <ion-input
          class="ion-text-end"
          id="address"
          type="text"
          formControlName="address"
        ></ion-input>
      </ion-item>

      <div class="px-3 error-message" *ngIf="userAddressForm.controls.address.errors?.required">Address is required.</div>
      
      <ion-item lines="full">
        <ion-label>
          <span translate="CITY"></span><span class="required-star">*</span>
        </ion-label>
        
        <ion-input
          class="ion-text-end"
          id="city"
          type="text"
          formControlName="city"
        ></ion-input>
      </ion-item>
      
      <div class="px-3 error-message" *ngIf="userAddressForm.controls.city.errors?.required"> City is required.</div>
      
      <ion-item lines="full">
        <ion-label [translate]="'DISTRICT'"></ion-label>
        <ion-input
          class="ion-text-end"
          id="district"
          type="text"
          formControlName="district"
        ></ion-input>
      </ion-item>
      
      <ion-item lines="full">
        <ion-label [translate]="'LANDMARK'"></ion-label>
        <ion-input
          class="ion-text-end"
          id="landmark"
          type="text"
          formControlName="landmark"
        ></ion-input>
      </ion-item>
      
      <ion-item lines="full">
        <ion-label>
          <span translate="STATE"></span><span class="required-star">*</span>
        </ion-label>
        
        <ion-input
          class="ion-text-end"
          id="city"
          type="text"
          formControlName="state"
        ></ion-input>
      </ion-item>
      
      <div class="px-3 error-message" *ngIf="userAddressForm.controls.state.errors?.required">State is required.</div>
      
      <ion-item lines="full">
        <ion-label>
          <span translate="COUNTRY"></span><span class="required-star">*</span>
        </ion-label>
        
        <ion-input
          class="ion-text-end"
          id="country"
          type="text"
          formControlName="country"
        ></ion-input>
      </ion-item>
      
      <div class="px-3 error-message" *ngIf="userAddressForm.controls.country.errors?.required"> Country is required.</div>
      
      <ion-item lines="full">
        <ion-label>
          <span translate="PIN_CODE"></span><span class="required-star">*</span>
        </ion-label>
        
        <ion-input
          class="ion-text-end"
          id="pinCode"
          type="text"
          formControlName="pinCode"
        ></ion-input>
      </ion-item>

      <div class="px-3 error-message" *ngIf="userAddressForm.controls.pinCode.errors?.required">Pincode is required.</div>
      
      <ion-item lines="full">
        <ion-label [translate]="'ADDRESS_TYPE'"></ion-label>
        <ion-input
          formControlName="addressType"
          type="text"
          class="ion-text-end"
          placeholder="HOME or OFFICE"
        ></ion-input>
      </ion-item>

      <ion-item lines="full">
        <ion-label [translate]="'ADDRESS_TYPE_CLASSIFICATION'"></ion-label>
        <ion-input
          class="ion-text-end"
          id="addressTypeClassification"
          type="text"
          formControlName="addressTypeClassification"
        ></ion-input>
      </ion-item>

      <ion-item lines="full">
        <ion-label [translate]="'LOCATION'" class="me-2"></ion-label>
        <ion-label *ngIf="userAddressForm.controls.location.value">
          Latitue: {{userAddressForm.controls.location.value.latitude}} Longitude: {{userAddressForm.controls.location.value.longitude}}
        </ion-label>
        <ion-button fill="outline" type="button" (click)="showMap(userAddressForm.controls.location)">Map</ion-button>
      </ion-item>

    </ion-list>
  </form>

  <section class="view-address smartdine-form" *ngIf="isViewAddress && editAddress">
    <ion-list>

      <ion-item *ngIf='editAddress.addressName.length !=0 || editAddress.addressName == null '>
        <ion-label>Address Name:</ion-label>
        <ion-text slot="end">{{ editAddress?.addressName }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.addressType.length !=0 || editAddress.addressType == null '>
        <ion-label>Address Type:</ion-label>
        <ion-text slot="end">{{ editAddress?.addressType }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.houseNumber.length !=0 || editAddress.houseNumber == null '>
        <ion-label>House Name:</ion-label>
        <ion-text slot="end">{{ editAddress?.houseNumber }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.buildingName.length !=0 || editAddress.buildingName == null '>
        <ion-label>Building Name:</ion-label>
        <ion-text slot="end">{{ editAddress?.buildingName }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.address.length !=0 || editAddress.address == null '>
        <ion-label>Address Line:</ion-label>
        <ion-text slot="end">{{ editAddress?.address }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.city.length !=0 || editAddress.city == null '>
        <ion-label>Your City:</ion-label>
        <ion-text slot="end">{{ editAddress?.city }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.district.length !=0 || editAddress.district == null '>
        <ion-label>District:</ion-label>
        <ion-text slot="end">{{ editAddress?.district }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.landmark.length !=0 || editAddress.landmark == null '>
        <ion-label>Landmark:</ion-label>
        <ion-text slot="end">{{ editAddress?.landmark }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.pinCode.length !=0 || editAddress.pinCode == null '>
        <ion-label>Your PinCode:</ion-label>
        <ion-text slot="end">{{ editAddress?.pinCode }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.country.length !=0 || editAddress.country == null '>
        <ion-label>Your Country:</ion-label>
        <ion-text slot="end">{{ editAddress?.country }}</ion-text>
      </ion-item>

      <ion-item *ngIf='editAddress.location == null '>
        <ion-label>Location:</ion-label>
        <ion-text slot="end">{{ editAddress?.location }}</ion-text>
      </ion-item>

    </ion-list>
  </section>

</ion-content>
